import { CapoPlugin } from "H:/Project/vana_front/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];